// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { connectDatabaseEmulator, getDatabase } from 'firebase/database'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
const origin = "localhost"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBYKXNfXLvX-Cl2wVzPns3Lj19mTDuo6D0",
    authDomain: "sgpolls.firebaseapp.com",
    projectId: "sgpolls",
    storageBucket: "sgpolls.appspot.com",
    messagingSenderId: "87031212698",
    appId: "1:87031212698:web:c4277eafdc585db1908d23",
    measurementId: "G-GW26QMF6QG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const database = getDatabase()
export const auth = getAuth()
export const functions = getFunctions()
export const firestore = getFirestore()
const analytics = getAnalytics(app);
// connectFunctionsEmulator(functions, origin, 5001)
// connectAuthEmulator(auth, "http://" + origin + ":9099")
// connectDatabaseEmulator(database, origin, 9000)
// connectFirestoreEmulator(firestore, origin, 8080)
